import Loading from '../../../Common/Loading';
import { BedroomsPerHouse } from './BedroomsPerHouse';
import { FamiliesPerHouse } from './FamiliesPerHouse';
import { HouseLocalization } from './HouseLocalization';
import { Indicators } from './Indicators';
import { PeoplePerHouse } from './PeoplePerHouse';
import { PeoplePerHouseType } from './PeoplePerHouseType';
import { RoomsPerHouse } from './RoomsPerHouse';
import { useHouseholdChartsDataContext } from './hooks/useHouseholdChartsDataContext';

export const Charts = () => {
    const { isLoading, data } = useHouseholdChartsDataContext();

    if (isLoading ) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="charts-side-by-side-dashboards">
                <PeoplePerHouseType />
                <BedroomsPerHouse />
                <RoomsPerHouse />
            </div>
            <div className="charts-side-by-side-dashboards">
                <HouseLocalization />
                <FamiliesPerHouse />
                <PeoplePerHouse />
            </div>
        </>
    );
};
